import CartDetailedItemComponentMobile from "./CartDetailedItemMobile.Component";

export default CartDetailedItemComponentMobile;
